import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';



Snappy.Component.EduSectionUpdater = class EduSectionUpdater extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-section-updater';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

    }

    setVars() {
        this.sectionName = this.$element.data('section-updater-value');
    }

    setEventListeners() {
        this.$window.on('content:updated', this.updateAttributes.bind(this));
    }

    updateAttributes() {
        const $items = this.$element.find('.js-section-updater-item');
        if ($items.length) {
            $items.attr('data-gtm-event-category', this.sectionName);
        }

    }


};



// WEBPACK FOOTER //
// ./components/edu-section-updater/scripts/edu-section-updater.js